<template>
  <div class="ring"></div>
</template>

<script>
export default {
  name: "",
  props: {
    data: Object,
  },
  data() {
    return {};
  },
  methods: {
    setChart() {
      let option = {
        tooltip: {
          trigger: "item",
          formatter: ({ value }) => {
            return value + "%";
          },
          backgroundColor: "#11367a",
          textStyle: {
            color: "#6dd0e3",
            fontSize: 10,
          },
        },
        title: {
          text: this.data.title,
          bottom: 10,
          x: "center",
          textStyle: {
            fontSize: 14,
            color: "rgba(255, 255, 255, 1)",
            fontWeight: "normal",
          },
        },
        series: [
          {
            center: ["50%", "40%"],
            name: this.data.title,
            type: "gauge",
            startAngle: 90,
            endAngle: -270,
            radius: "65%",
            progress: {
              show: true,
              width: 6,
              roundCap: true,
              itemStyle: {
                color: {
                  type: "linear",
                  x: 1,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(255, 57, 80, 1)", // 0% 处的颜色
                    },
                    {
                      offset: 0.5,
                      color: "rgba(255, 186, 0, 1)", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(191, 157, 99, 1)", // 100% 处的颜色
                    },
                  ],
                },
              },
            },
            axisLine: {
              roundCap: true,
              lineStyle: {
                width: 2,
                color: [[1, "rgba(191, 157, 99, 1)"]],
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            pointer: {
              show: false,
            },
            detail: {
              fontSize: 12,
              offsetCenter: [0, "10%"],
              formatter: (value) => {
                return `{title|${value}}` + "\n" + "{detail|亿元}";
              },
              rich: {
                title: {
                  fontSize: 22,
                  color: "rgba(255, 255, 255, 0.8)",
                },
                detail: {
                  lineHeight: 16,
                  color: "rgba(255, 255, 255, 0.5)",
                },
              },
            },
            data: this.data.data,
          },
        ],
      };
      console.log(this.data.data);
      let myChart = this.$echarts(this.$el);
      myChart.clear();
      myChart.resize();
      myChart.setOption(option);
    },
  },
  mounted() {
    this.setChart();
  },
};
</script>

<style lang="less" scoped>
.ring {
  width: 100%;
  height: 100%;
}
</style>
